import { inject, injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { TicketCountPreloaderService } from '@/services/preloaders/ticketCountPreloaderService'

@injectable()
export class TicketCountResolverService implements Resolvable {
  @inject(SERVICE_TYPES.TicketCountPreloaderService)
  protected readonly ticketCountPreloaderService: TicketCountPreloaderService

  public async resolve() {
    await this.ticketCountPreloaderService.preloadUnreadTicketsCount()
  }
}
